module.exports = __webpack_public_path__ + "static/media/downArrowPurple.daa798d1.svg";